var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFamily(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: "512px",
    viewBox: "0 0 512 512",
    width: "512px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m356.099 85.601h30c0 8.457 6.88 15.336 15.336 15.336h38.536c-1.576-36.682-31.802-65.941-68.872-65.941s-67.296 29.258-68.872 65.941h38.536c8.456 0 15.336-6.88 15.336-15.336z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF7007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m371.099 211.963c38.079 0 68.948-30.869 68.948-68.948v-12.078h-38.612c-11.654 0-22.296-4.421-30.336-11.673-8.04 7.251-18.683 11.673-30.336 11.673h-38.613v12.078c0 38.079 30.869 68.948 68.949 68.948z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF7007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.292 67.181c0-17.836-14.504-32.27-32.34-32.184l-101.99.285c-17.681.132-31.945 14.502-31.945 32.184v25.464h166.275z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF7007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m117.456 212.26c38.017 0 68.836-30.819 68.836-68.836v-20.495h-137.673v20.495c0 38.017 30.819 68.836 68.837 68.836z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF7007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 345.691c27.378 0 49.572-22.194 49.572-49.572v-28.091c0-27.378-22.194-49.572-49.572-49.572s-49.572 22.194-49.572 49.572v28.091c0 27.378 22.194 49.572 49.572 49.572z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF7007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.178 351.374c-14.478 14.977-34.752 24.317-57.178 24.317s-42.7-9.34-57.178-24.317c-16.184 8.278-27.27 25.104-27.27 44.53v81.1h168.896v-81.1c0-19.426-11.086-36.252-27.27-44.53z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF7007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176.428 296.119v-28.091c0-20.879 8.095-39.895 21.296-54.104-3.07-.812-6.253-1.342-9.523-1.556-17.963 18.428-43.039 29.892-70.745 29.892-27.701 0-52.772-11.46-70.734-29.881-26.085 1.69-46.722 23.369-46.722 49.881v132.342h141.575c.457-28.597 15.905-54.448 40.769-68.419-3.803-9.282-5.916-19.429-5.916-30.064z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF7007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m441.89 212.072c-17.981 18.429-43.071 29.892-70.791 29.892-16 0-31.123-3.822-44.511-10.594 5.727 10.979 8.985 23.442 8.985 36.658v28.091c0 10.635-2.113 20.782-5.916 30.064 24.864 13.971 40.312 39.822 40.769 68.419h118.32v-132.639c-.001-26.557-20.708-48.267-46.856-49.891z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF7007"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m467.92 83.51c1.391 6.596 2.127 13.431 2.127 20.434v39.07c0 15.021-3.367 29.268-9.383 42.032 16.181 4.612 30.227 14.179 40.453 26.917h10.883v-62.101c0-29.855-18.184-55.46-44.08-66.352z",
    "data-original": "#000000",
    className: "active-path",
    "data-old_color": "#000000",
    fill: "#FF7007"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/family.94b0da731280a043f7d8e9f30865e608.svg";
export { ForwardRef as ReactComponent };